<template>
    <div class="pushProject">
        <leftnav class="fl" :mkcode="yj_mkcode" :itemcode="yj_itemcode" docutitle="推项目"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <div class="index_left_centerpage">
                <div class="whitebox right_topbox">
                    <div class="right_boxtitle map_title_tab">
                        <span :class="currentTab == item.value ? 'current title' : 'title'" v-for="(item) in tabList"
                            v-show="currentTab == item.value && currentTab != 5" @click="tabClick(item)"
                            :key="'tabList' + item.value">{{ item.text }}
                        </span>
                        <span v-show="currentTab == 5" :class="navValue == 0 ? 'current title' : 'title'"
                            @click="currentTab = 5; navValue = ''; ajaxsearchcompany(1);">全部项目</span>
                        <span v-show="currentTab == 5" :class="navValue == item.value ? 'current title' : 'title'"
                            v-for="(item) in navList" @click="navclick(item)" :key="'nav' + item.value">{{ item.text }}
                        </span>

                    </div>
                </div>
                <div class="enterprise_list_box whitebox">
                    <div class="enterparise_guide oh" style="width: 95%; ">
                        <p class="fl">为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
                    </div>
                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
                        v-show="currentTab == 3 && enterpristlist.length > 0">
                        <tr>
                            <th>项目名称</th>
                            <!-- <th>企业名称</th> -->
                            <th>投资金额</th>
                            <th>年产值</th>
                            <th>产业类型</th>
                            <th>预匹配市州</th>
                            <th>备注</th>
                            <!-- <th>评估状态</th>-->
                            <th>项目类型</th>

                            <!-- <th>推送状态</th> -->
                            <th>推送</th>
                        </tr>
                        <tr v-for="item in enterpristlist" :key="item.stockcode">
                            <td @click="detailrouterto('/workbenchEnterpriseDetails', item.id)" class="title">
                                {{ item.customerName }}</td>
                            <!-- <td>{{item.companyName}}</td> -->
                            <td>{{ item.amount || '-' }}<span class="font-14" v-show="item.amount != ''">(亿元)</span>
                            </td>
                            <td>{{ item.outputValue || '-' }}<span class="font-14"
                                    v-show="item.outputValue != ''">(亿元)</span></td>
                            <td>{{ item.smallClassText || '-' }}</td>
                            <td>{{ item.assessmentDetail.city || '-' }}</td>
                            <td>{{ item.remark || '-' }}</td>
                            <!-- <td>{{item.assessmentText || '-'}}</td> -->
                            <td>{{ item.projectTypeText || '-' }}</td>

                            <!-- <td>{{item.pushText ||'未推送'}}</td> -->
                            <td class="cur-pointer bluefont" @click="initiatePopup(item)">
                                <span>推送 ></span>
                            </td>
                        </tr>
                    </table>
                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
                        v-show="(currentTab == 4 || currentTab == 5) && enterpristlist.length > 0">
                        <tr>
                            <th>项目名称</th>
                            <th>投资额(亿元)</th>
                            <th>年产值(亿元)</th>
                            <!-- <th>企业名称</th> -->
                            <th>产业类型</th>
                            <th>预匹配市州</th>

                            <!-- <th>评估状态</th> -->
                            <th>项目类型</th>

                            <!-- <th>推送状态</th> -->
                            <th>推送给目标单位</th>
                            <th v-show="currentTab == 4">项目跟踪人</th>
                            <th v-show="currentTab == 5">项目推荐人</th>
                            <th>备注</th>
                        </tr>
                        <tr v-for="item in enterpristlist" :key="item.stockcode">
                            <td @click="detailrouterto('/workbenchEnterpriseDetails', item.id)" class="title">
                                {{ item.project }}</td>
                            <!-- <td>{{item.companyName}}</td> -->
                            <td>{{ item.amount || '-' }}</td>
                            <td>{{ item.outputValue || '-' }} </td>
                            <td>{{ item.smallClassText || '-' }}</td>
                            <td>{{ item.assessmentDetail.city || '-' }}</td>

                            <!-- <td>{{item.assessmentText || '-'}}</td> -->
                            <td>{{ item.projectTypeText || '-' }}</td>

                            <!-- <td>{{item.pushText || '-'}}</td> -->
                            <td class="text-left">
                                <p>主送：{{ item.pushDetail.mainUnitText || '-' }}</p>
                                <p>抄送：{{ item.pushDetail.secondUnitText || '-' }}</p>
                            </td>
                            <td class="whiteSpe">{{ currentTab == 4 ? item.receiveUsername : item.pushUsername }}</td>
                            <td>{{ item.remark || '-' }}</td>
                        </tr>
                    </table>
                </div>
                <div class="centerpage1 company_pagelist" v-show="totalPage > 1">
                    <zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
                        v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
                </div>

                <el-dialog :before-close="closeDialog" class="localChain" custom-class="initiate_box_dialog"
                    title="项目推送" center width="850px" :visible.sync="isInitiate" top="25vh">


                    <el-form :model="form" ref="pushForm">
                        <div class="initiate_box">
                            <!-- <el-row class="mb-1">
                                <el-col :span="6" class="initiate_title">推送方式：</el-col>
                                <el-col :span="18">
                                    <el-radio-group v-model="multipleType">
                                        <el-radio :label="1" border>城市</el-radio>
                                        <el-radio :label="2" border>单位</el-radio>
                                    </el-radio-group>
                                </el-col>
                            </el-row> -->
                            <el-row class="mb-1">
                                <el-col :span="6" class="initiate_title">项目类型设置：</el-col>
                                <el-col :span="18">
                                    <el-select v-model="form.projectType" @change="hanlderClass" placeholder="请选择项目类型">
                                        <el-option v-for="item in projectTypeList" :key="'projectType' + item.value"
                                            :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                            <el-row class="mb-1" v-show="temProjectType != '3'">
                                <el-col :span="6" class="initiate_title">主送：</el-col>
                                <!-- <el-col :span="18" v-show="multipleType == 2">
                                    <el-select v-model="form.mainUnit" placeholder="请选择主送" :disabled="form.keepself" 
                                        @change="mainUnitChange">
                                        <el-option v-for="item in mainUnitList" :key="'mainUnitList' +item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-col> -->
                                <el-col :span="18" v-show="multipleType == 1">
                                    <!-- 当选择主送城市变化时触发 mainUnitMpeChange，更新接收人分组 -->
                                    <el-select v-model="form.mainMpeUnit" multiple placeholder="请选择主送"
                                        :disabled="form.keepself" @change="mainUnitMpeChange">
                                        <el-option v-for="item in hunanCity" :key="'mainUnitListM' + item.areaId"
                                            :label="item.areaName" :value="item.areaId">
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                            <!-- <el-row class="mb-1" v-show="temProjectType != 3">
                                <el-col :span="6" class="initiate_title">{{ temProjectType == 1 ? '抄送' : '主送' }}：</el-col>
                                <el-col :span="18">
                                    <el-select v-model="form.secondUnit" @change="secondUnitChange" v-show="multipleType == 2"
                                        :placeholder="'请选择' + (temProjectType == 1 ? '抄送' : '主送')" :disabled="form.keepself">
                                        <el-option v-for="item in secondUnitList" :key="'secondUnitList' +item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <el-select multiple v-model="form.secondMpeUnit" @change="secondUnitMpeChange" v-show="multipleType == 1"
                                        :placeholder="'请选择' + (temProjectType == 1 ? '抄送' : '主送')" :disabled="form.keepself">
                                        <el-option v-for="item in hunanCity" :key="'secondUnitListM' +item.areaId" :label="item.areaName"
                                            :value="item.areaId">
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row> -->
                            <el-row class="mb-1">
                                <el-col :span="6" class="initiate_title">附件：</el-col>
                                <el-col :span="18">
                                    <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
                                        :on-preview="handlePreview" :on-remove="handleRemove" multiple :limit="1"
                                        :before-remove="beforeRemove" :on-success="handleAvatarSuccess"
                                        :on-exceed="handleExceed" :file-list="form.file"
                                        :show-file-list="form.showFileList"
                                        accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.gif">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">仅支持上传 Word、PDF、图片文件，且文件大小不超过
                                            30MB</div>
                                    </el-upload>
                                </el-col>
                            </el-row>
                            <el-row class="mb-1">
                                <el-col :span="6" class="initiate_title">备注：</el-col>
                                <el-col :span="18">
                                    <el-input type="textarea" v-model="form.remark" :rows="3"
                                        placeholder="请输入备注信息"></el-input>

                                </el-col>
                            </el-row>


                            <el-row class="mb-2" v-show="temProjectType != 3">
                                <!-- <el-col :span="4" class="initiate_title">自己保留项目：</el-col>
                            <el-col :span="8">
                               <el-checkbox v-model="form.keepself" size="medium "> </el-checkbox>
                            </el-col> -->
                                <el-col :span="6" class="initiate_title">选择项目接收人：</el-col>
                                <el-col :span="18">
                                    <el-select v-model="form.receiveUser" placeholder="请选择项目接收人"
                                        v-show="multipleType == 2" :disabled="form.keepself">
                                        <el-option v-for="item in recipientList" :key="'receiveUser' + item.id"
                                            :label="item.userName" :value="item.id">
                                        </el-option>
                                    </el-select>

                                    <!-- 每个被选的主送城市单独一个接收人选择框 -->
                                    <div v-show="multipleType == 1">
                                        <div v-for="cityId in form.mainMpeUnit" :key="cityId" class="mb-2">
                                            <div style="margin-bottom:6px;font-weight:600;">
                                                {{ getCityName(cityId) }} 项目接收人：
                                            </div>
                                            <el-select v-model="form.receiveUserByCity[cityId]" multiple
                                                :placeholder="getUsersByCityId(cityId).length === 0 ? '无接收人' : '请选择项目接收人'"
                                                :disabled="form.keepself || getUsersByCityId(cityId).length === 0"
                                                style="width:100%;">
                                                <el-option v-for="user in getUsersByCityId(cityId)" :key="user.id"
                                                    :label="user.userName" :value="user.id"></el-option>
                                                <el-option v-if="getUsersByCityId(cityId).length === 0"
                                                    :key="'empty_' + cityId" :label="'无接收人'" :value="null" disabled>
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>

                                </el-col>
                            </el-row>
                        </div>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="closeInitiate">取 消</el-button>
                        <el-button type="primary" @click="submitInitiate">提 交</el-button>
                    </span>
                </el-dialog>

            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { dataInJs } from "../../utils/city.js";
export default {
    name: 'pushProject',
    data() {
        return {
            currentTab: '3',
            userdata: {},
            provincedata: dataInJs(),
            hunanCity: dataInJs().filter(item => item.areaId == 43)[0].children,
            tabList: [
                { value: '3', text: '全部项目', num: 0, itemcode: 'F-wtsxm' },
                { value: '4', text: '已推送项目', num: 0, itemcode: 'F-ytsxm' },
                { value: '5', text: '已接收项目', num: 0, itemcode: 'F-yjsxm' },
            ],
            navList: [
                { value: 1, text: 'A类项目', },
                { value: 2, text: 'B类项目', },
                { value: 3, text: 'C类项目', },
            ],
            navValue: '',
            yj_mkcode: 'F',
            yj_itemcode: 'pxm',
            enterpristlist: [],
            recipientList: [],
            temdialogData: {},
            projectTypeList: [],
            form: {
                receiveUser: '',
                projectType: '',
                keepself: false, //自己保留项目
                mainUnit: '',//主送
                secondUnit: '',//抄送
                showFileList: true,
                file: [],
                remark: '',
                mainMpeUnit: [],//主送城市多选
                secondMpeUnit: [],//抄送城市多选
                receiveUserMpe: [],//旧字段保留（兼容）
                receiveUserByCity: {}, // 新： { cityId: [userId,...], ... }
            },
            isInitiate: false,
            temProjectType: '', //临时保存项目类型 ABC
            page: 1, //显示的是哪一页
            haspage: true, //是否还有下一页
            pageSize: 10, //每一页显示的数据条数
            total: 0, //记录总数
            totalPage: 1,
            maxPage: 10, //最大页数 
            mainUnitList: [],
            secondUnitList: [],
            allSecondUnitList: [],//备份抄送列表方便主送切换的时候对应
            allRecipientList: [],
            multipleType: 1,//是否批量推送，暂时默认为1，后续根据需求调整
            recipientMpeList: [], // 接收人分组（每项 { cityId, cityName, users: [...] }）
            // 新增：城市映射表
            cityMap: {}, // 用于快速查找城市 { areaId: { areaName, ... } }
        }
    },
    computed: {
        ...mapState({ isCollapse: (state) => state.isCollapse, }),
        ...mapGetters(['isCollapse'])
    },

    components: {
    },
    mounted() {
        this.ajaxsearchcompany(1);
        this.getProjectTypeList(); // 获取项目类型列表
        this.getRecipientList(); // 获取接收人列表
        this.getMainUnitList(1);
        this.getMainUnitList(2);
    },
    created() {
        this.userdata = this.getuseriformation();
        this.currentTab = this.$route.query.type;
        let currentTabItem = this.tabList.find(item => item.value == this.currentTab);
        if (currentTabItem) {
            this.yj_itemcode = currentTabItem.itemcode;
        }
    },
    //监听路由变化
    watch: {
        $route: function (newVal, oldVal) {
            this.currentTab = this.$route.query.type;
            let currentTabItem = this.tabList.find(item => item.value == this.currentTab);
            if (currentTabItem) {
                this.yj_itemcode = currentTabItem.itemcode;
            }
            this.ajaxsearchcompany(1);
        }
    },
    methods: {
        // 初始化城市映射表
        initCityMap() {
            this.cityMap = {};
            this.hunanCity.forEach(city => {
                this.cityMap[city.areaId] = city;
            });
        },

        secondUnitMpeChange(val) {
            console.log('主送', val);
            // this.form.mainMpeUnit = val;
        },

        mainUnitMpeChange(selectedCityIds) {
            console.log('选中城市', selectedCityIds);
            // selectedCityIds: [areaId,...]
            if (!selectedCityIds || selectedCityIds.length === 0) {
                this.recipientMpeList = [];
                return;
            }

            // 根据 hunanCity 找到被选城市的名称，并为每个城市构建用户列表
            const groups = [];
            selectedCityIds.forEach(cityId => {
                const city = this.cityMap[cityId];
                if (city) {
                    const cityName = city.areaName;
                    const users = this.allRecipientList.filter(u => {
                        // 精确匹配：接收人的city字段对应hunanCity的areaId
                        return u.city === cityId;
                    });
                    groups.push({
                        cityId: cityId,
                        cityName: cityName + '项目接收人',
                        users: users
                    });
                }
            });
            this.recipientMpeList = groups;
            console.log('接收人分组', this.recipientMpeList);
        },

        // --- 新增：根据 areaId 返回市名，模板中调用 getCityName(cityId)
        getCityName(cityId) {
            if (cityId === null || cityId === undefined || cityId === '') return '';
            const city = this.cityMap[cityId];
            return city ? city.areaName : '';
        },

        // 根据 areaId 返回该市的接收人数组
        getUsersByCityId(cityId) {
            if (cityId === null || cityId === undefined || cityId === '') return [];
            if (!this.cityMap[cityId]) return [];

            const list = this.allRecipientList || [];
            // 精确匹配：接收人的city字段等于城市ID
            return list.filter(u => u.city === cityId);
        },

        //批量推送
        pushMultiple() {

            let fileD = '';
            for (let i = 0; i < this.form.file.length; i++) {
                fileD = this.form.file[i].raw;
            }
            let formData = new FormData();
            if (this.temProjectType == 1) { //A类
                formData.append('mainUnit', this.form.mainMpeUnit.join(','));
                formData.append('secondUnit', this.form.secondMpeUnit.join(','));
            } else if (this.temProjectType == 2) { //B类
                formData.append('mainUnit', this.form.secondMpeUnit.join(','));
                formData.append('secondUnit', '');
            } else if (this.temProjectType == 3) { //C类
                formData.append('mainUnit', '');
                formData.append('secondUnit', '');
            }
            formData.append('customerId', this.temdialogData.id);
            //    formData.append('keepself', this.form.keepself ? 1 : 0);
            // 合并各城市选择的接收人
            const combined = [];
            Object.values(this.form.receiveUserByCity || {}).forEach(arr => {
                if (Array.isArray(arr)) arr.forEach(v => { if (v) combined.push(v); });
            });
            formData.append('receiveUser', combined.join(','));
            formData.append('projectType', this.form.projectType);
            formData.append('file', fileD);
            formData.append('remark', this.form.remark);
            // 打印 FormData 内容（调试用）
            for (let [key, value] of formData.entries()) {
                console.log(`${key}:`, value);
            }
            let that = this;
            let ajaxurl = this.$api.crm.push.Multiple();
            console.log("提交数据", this.form, this.temProjectType);
            // return;
            if (this.form.projectType <= 0) {
                this.$message.warning('请选择项目类型');
                return;
            }
            $.ajax({
                type: "post",
                url: ajaxurl,
                headers: {
                    AuthToken: this.userdata.token
                },
                data: formData,
                processData: false,  // 重要：不要让 jQuery 处理数据
                contentType: false,  // 重要：不要让 jQuery 设置内容类型
                success: function (res) {
                    if (res.success) {
                        that.$message({
                            message: '提交成功',
                            type: 'success'
                        })
                        that.isInitiate = false;
                        that.ajaxsearchcompany(1);
                    } else {
                        that.$message.error(res.msg);
                    }
                },
            });


        },
        //单个推送
        pushSingle() {
            let fileD = '';
            for (let i = 0; i < this.form.file.length; i++) {
                fileD = this.form.file[i].raw;
            }
            let formData = new FormData();
            if (this.temProjectType == 1) {
                formData.append('mainUnit', this.form.mainUnit);
                formData.append('secondUnit', this.form.secondUnit);
            } else if (this.temProjectType == 2) {
                formData.append('mainUnit', this.form.secondUnit);
                formData.append('secondUnit', '');
            } else if (this.temProjectType == 3) {
                formData.append('mainUnit', '');
                formData.append('secondUnit', '');
            }
            formData.append('customerId', this.temdialogData.id);
            //    formData.append('keepself', this.form.keepself ? 1 : 0);
            if (this.multipleType == 1) {
                const combined = [];
                Object.values(this.form.receiveUserByCity || {}).forEach(arr => {
                    if (Array.isArray(arr)) arr.forEach(v => { if (v) combined.push(v); });
                });
                formData.append('receiveUser', combined.join(','));
            } else {
                formData.append('receiveUser', this.form.receiveUser);
            }
            formData.append('projectType', this.form.projectType);
            formData.append('file', fileD);
            formData.append('remark', this.form.remark);
            // 打印 FormData 内容（调试用）
            for (let [key, value] of formData.entries()) {
                console.log(`${key}:`, value);
            }
            let that = this;
            let ajaxurl = this.$api.crm.push.post();
            console.log("提交数据", this.form, this.temProjectType);
            if (this.form.projectType <= 0) {
                this.$message.warning('请选择项目类型');
                return;
            }
            $.ajax({
                type: "post",
                url: ajaxurl,
                headers: {
                    AuthToken: this.userdata.token
                },
                data: formData,
                processData: false,  // 重要：不要让 jQuery 处理数据
                contentType: false,  // 重要：不要让 jQuery 设置内容类型
                success: function (res) {
                    if (res.success) {
                        that.$message({
                            message: '提交成功',
                            type: 'success'
                        })
                        that.isInitiate = false;
                        that.ajaxsearchcompany(1);
                    } else {
                        that.$message.error(res.msg);
                    }
                },
            });

        },
        navclick(item) {
            this.navValue = item.value;
            this.ajaxsearchcompany(1);
        },
        //主送发生改变，对应的抄送列表发生改变
        mainUnitChange(val) {
            this.form.secondUnit = '';
            if (this.form.projectType == 1) {
                //主送和抄送列表对比provice和city，抄送列表和主送相同的保留
                const selectedItem = this.mainUnitList.find(item => item.value === val);

                // 如果没有备份列表直接返回
                if (!this.allSecondUnitList || this.allSecondUnitList.length === 0) return;
                // 若未选中主送，则恢复完整抄送列表（排除主送自身）
                if (!selectedItem) {
                    this.secondUnitList = this.allSecondUnitList.filter(i => i.value !== val);
                    return;
                }
                // 使用 province/city 字段匹配筛选抄送列表，保留与主送相同省市的项且排除主送自身
                this.secondUnitList = this.allSecondUnitList.filter(i => {
                    const sameProvince = (i.province === selectedItem.province);
                    const sameCity = (i.city === selectedItem.city);
                    const notSelf = i.value !== val;
                    return notSelf && (sameProvince && sameCity);
                });
                this.recipientList = this.allRecipientList.filter(i => {
                    const sameProvince = (i.province === selectedItem.province);
                    const sameCity = (i.city === selectedItem.city);
                    const notSelf = i.value !== val;
                    return notSelf && (sameProvince && sameCity);
                });
                // 若筛选后为空，则回退为排除主送的完整列表（避免没有选项）
                if (this.secondUnitList.length === 0) {
                    this.secondUnitList = this.allSecondUnitList.filter(i => i.value !== val);
                }
            } else {
                // this.form.mainUnit = '';
                this.secondUnitList = this.allSecondUnitList;
            }
        },
        secondUnitChange(val) {
            const selectedItem = this.secondUnitList.find(item => item.value === val);
            this.recipientList = this.allRecipientList.filter(i => {
                const sameProvince = (i.province === selectedItem.province);
                const sameCity = (i.city === selectedItem.city);
                const notSelf = i.value !== val;
                return notSelf && (sameProvince && sameCity);
            });
        },
        //获取主送列表
        getMainUnitList(type) {
            let ajaxurl = this.$api.crm.Unit.list() + '?type=' + type;
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then((res) => {
                if (res.data.success) {
                    if (type == 1) { this.mainUnitList = res.data.list; }
                    if (type == 2) { this.secondUnitList = res.data.list; this.allSecondUnitList = res.data.list; }
                }
            })
        },
        /**
         * 项目类型改变
         * @param {Number} value - 选中的项目类型值
         */
        hanlderClass(value) {
            console.log("项目类型改变", value);
            this.mainUnitChange('');
            this.temProjectType = Number(value); // 保持为 Number，

        },
        /**
         * 关闭发起推送弹框
         */
        closeDialog() {
            this.isInitiate = false;
            this.form = {
                receiveUser: '',
                projectType: '',
                keepself: false,
                mainUnit: '',  // 主送单位
                secondUnit: '', // 抄送单位
                showFileList: true,
                file: [],
                remark: '',
                mainMpeUnit: [],  // 主送城市多选
                secondMpeUnit: [], // 抄送城市多选
                receiveUserMpe: [], // 旧字段保留（兼容）
                receiveUserByCity: {}, // 接收人按城市分组
            };
            // 清空临时数据
            this.temdialogData = {};
            this.temProjectType = '';
            this.recipientMpeList = [];
        },
        /**
         * 文件删除回调
         * @param {Object} file - 被删除的文件
         * @param {Array} fileList - 文件列表
         */
        handleRemove(file, fileList) {
            // console.log(file, fileList);
            this.deleteFile(file.id).then((res) => {
                console.log('删除成功31232131231233');
                this.project.file = fileList; // 更新文件列表 
            })

            console.log(file, fileList);
        },

        /**
         * 文件预览回调
         * @param {Object} file - 需要预览的文件
         */
        handlePreview(file) {
            window.open(file.url);
        },        /**
         * 文件删除之前回调
         * @param {Object} file - 要删除的文件
         * @param {Array} fileList - 文件列表
         */
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        /**
         * 文件上传数量超出限制回调
         * @param {Object} files - 上传的文件
         * @param {Object} fileList - 上传的文件列表
         */
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        /**
         * 文件上传成功回调
         * @param {Object} res - 上传结果
         * @param {Object} file - 上传的文件
         * @param {Array} fileList - 上传的文件列表
         */
        handleAvatarSuccess(res, file, fileList) {
            this.form.file = fileList; // 更新文件列表
            console.log(res, file);
        },
        //详情页跳转
        detailrouterto(path, id) {
            if (id == 0 || id == "") {
                return;
            }
            this.routerlinkarry(path, { id: id });
        },
        //获取项目类型列表
        getProjectTypeList() {
            this.bus.$emit('loading', true);
            var _this = this;
            let ajaxurl = this.$api.crm.parameter.projectType();
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {
                if (res.data.success) {
                    let datalist = res.data.list;
                    _this.projectTypeList = datalist;
                    _this.bus.$emit('loading', false);
                }
            })
        },
        // 获取接收人列表
        getRecipientList() {
            this.bus.$emit('loading', true);
            var _this = this;
            let ajaxurl = this.$api.crm.user.pushList();
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {
                if (res.data.success) {
                    let datalist = res.data.list;
                    _this.recipientList = datalist;
                    _this.allRecipientList = res.data.list;
                    // 初始化城市映射表
                    _this.initCityMap();
                    // 清空接收人分组
                    _this.recipientMpeList = [];
                    _this.bus.$emit('loading', false);
                }
            })
        },
        closeInitiate() {
            this.isInitiate = false;
        },
        //提交推送
        submitInitiate() {
            if (this.multipleType == 1) {
                this.pushMultiple();
            } else {
                this.pushSingle();
            }
        },
        //发起项目评估弹框
        initiatePopup(item) {
            // 先清空之前的选择
            this.form.mainMpeUnit = [];
            this.form.receiveUserByCity = {};
            this.recipientMpeList = [];

            this.temdialogData = item;
            this.temProjectType = item.projectType;
            this.form.projectType = item.projectType;
            this.isInitiate = true;
            console.log("发起项目评估", item, this.temProjectType);
        },
        // 标签切换
        tabClick(item) {
            this.currentTab = item.value;
            this.ajaxsearchcompany(1);
        },
        ajaxsearchcompany(page) {
            this.page = page || 1;
            // 获取项目列表
            this.bus.$emit('loading', true);
            var _this = this;
            let ajaxurl1 = this.$api.crm.project.list() + '?page=' + page + '&pageSize=' + this.pageSize + '&menu=' + this.currentTab + '&projectType=' + this.navValue;
            this.$axios.get(ajaxurl1, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {

                console.log("项目列表", res.data);
                if (res.data.success) {
                    _this.enterpristlist = res.data.list;
                    _this.pageSize = res.data.pageSize//每一页显示的数据条数
                    _this.total = res.data.totalRecord//每一页显示的数据条数
                    _this.totalPage = res.data.totalPage//每一页显示的数据条数

                } else {
                    _this.$message.error(res.data.msg);
                }
                _this.bus.$emit('loading', false);

            }).catch(function (err) {
                console.log(err);
            });
        },
        pageHandler: function (page) {
            this.ajaxsearchcompany(page, 'sort', 'search');
        },
    }
}
</script>

<style scoped lang="scss">
.whiteSpe {
    /* 默认值：合并空白，自动换行 */
    white-space: normal;

    /* 不换行，所有文本在一行 */
    white-space: nowrap;

    /* 保留空白和换行，不自动换行（类似<pre>） */
    white-space: pre;

    /* 保留空白序列，但自动换行 */
    white-space: pre-wrap;

    /* 合并空白序列，但保留换行 */
    white-space: pre-line;
}

.enterprise_list_box {
    min-height: 75vh;
}

.initiate_box {
    font-size: 16px;
    width: 85%;
    margin: 0 auto;

    ::v-deep {
        &.el-select {
            width: 100%;
        }
    }
}

.initiate_title {
    font-weight: 600;
}

.initiate_box_dialog {
    border-radius: 10px;
}
</style>